import BasePage from "@Scripts/Pages/BasePage";

export default class RegisterPage extends BasePage {
    public static async init() {
        await super.init();

        this.setPrivacyPolicy();
    }

    private static setPrivacyPolicy() {
        let privacyPolicyButton = document.getElementById("PrivacyPolicyButton"),
            privacyPolicyBox = document.getElementById("PrivacyPolicyBox");

        if (privacyPolicyButton) {
            privacyPolicyButton.addEventListener("click", function () {
                if (privacyPolicyBox) {
                    privacyPolicyBox.classList.toggle("hden");
                }
            });
        }
    }
}